// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-gallery-block {
  margin-bottom: 1px;
  padding: 1px;
}
.skeleton-gallery-block__col {
  padding: 3px;
}
.skeleton-gallery-block__cell {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 0px;
  overflow: hidden;
}
.skeleton-gallery-block__cell ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gallery/skeleton-gallery-block/skeleton-gallery-block.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAAN","sourcesContent":[".skeleton-gallery-block {\n  margin-bottom: 1px;\n  padding: 1px;\n\n  &__col {\n    padding: 3px;\n  }\n\n  &__cell {\n    width: 100%;\n    aspect-ratio: 1;\n    border-radius: 0px;\n    overflow: hidden;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
